var Tooltip = require('./base');

Tooltip.Html = require('./html');
Tooltip.Canvas = require('./canvas');
Tooltip.Mini = require('./mini');
module.exports = Tooltip;


//////////////////
// WEBPACK FOOTER
// ./src/tooltip/index.js
// module id = 278
// module chunks = 0